// extracted by mini-css-extract-plugin
module.exports = {"modal":"PhotoWatermarkSessionModal_modal__1ytM9","watermark":"PhotoWatermarkSessionModal_watermark__ggPIQ","disabled":"PhotoWatermarkSessionModal_disabled__5tSDC"};